module.exports = __webpack_public_path__ + "static/media/4-ball.72214f9d.png";